import styled from 'styled-components'

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.secondary};
  border-radius: 10px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`

export const ProviderName = styled.p`
  ${({ theme }) => theme.fonts.infoLG};
  color: ${({ theme }) => theme.colors.neutralL5};
  flex: 1;
`

export const PriceContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.secondaryL1};
  border-radius: 10px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const PriceLine = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const PricePrefix = styled.span`
  ${({ theme }) => theme.fonts.titleSM};
  color: ${({ theme }) => theme.colors.neutralL4};
`

export const PriceValue = styled.span`
  ${({ theme }) => theme.fonts.titleLG};
  color: ${({ theme }) => theme.colors.neutralL5};
`

export const PriceUnit = styled.span`
  ${({ theme }) => theme.fonts.titleSM};
  color: ${({ theme }) => theme.colors.neutralL4};
`

export const PriceMissing = styled.span`
  ${({ theme }) => theme.fonts.infoLG};
  color: ${({ theme }) => theme.colors.neutralL1};
`

export const UpdatedAt = styled.p`
  ${({ theme }) => theme.fonts.infoMD};
  color: ${({ theme }) => theme.colors.neutralL1};
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const PhoneList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const PhoneRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`

export const PhoneIcon = styled.img`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`

export const NotesRow = styled.div`
  display: flex;
  gap: 8px;
`

export const DetailText = styled.p`
  ${({ theme }) => theme.fonts.infoLG};
  max-width: 90%;
  color: ${({ theme }) => theme.colors.neutralL5};
`
